import { Core } from "@faire/design-tokens";
import styled, { css, keyframes } from "styled-components";
var anim = keyframes([
    "0%{opacity:1;}50%{opacity:0.5;}100%{opacity:1;}"
]);
export var GhostBlock = styled.div.withConfig({
    componentId: "sc-580cb09b-0"
})([
    "width:",
    ";height:",
    ";background-color:",
    ";animation:",
    " 2s ease-out infinite;cursor:progress;border-radius:",
    ";",
    ""
], function(props) {
    var _props_$width;
    return (_props_$width = props.$width) !== null && _props_$width !== void 0 ? _props_$width : "100%";
}, function(props) {
    var _props_$height;
    return (_props_$height = props.$height) !== null && _props_$height !== void 0 ? _props_$height : "100%";
}, Core.surface.subdued, anim, function(props) {
    var _props_$borderRadius;
    return (_props_$borderRadius = props.$borderRadius) !== null && _props_$borderRadius !== void 0 ? _props_$borderRadius : "0%";
}, function(props) {
    return props.$aspectRatio ? css([
        "aspect-ratio:",
        ";"
    ], props.$aspectRatio) : "";
});
